import { register } from 'swiper/element/bundle';
import { initGeographyMapLazy } from './geographyMap.js';
import { initServicesSlider } from './servicesSlider.js';
import { initAdvantagesSlider } from './advantagesSlider.js';
import { fixNavLinkWidths } from './navFix.js';
import { initHeroLazyLoad } from './heroLazyLoad.js';
import { initGoalsLazyLoad } from './goalsLazyLoad.js';
import { initHeaderScroll } from './headerScroll.js';
import { initMenu } from './menu.js';
import SubscriptionModal from './subscriptionModal.js';
// import GratitudeModal from './gratitudeModal.js';
import { setupClientsInfo } from './clientsInfo.js';

export function initApp() {
  register();
  fixNavLinkWidths();
  initHeroLazyLoad();
  initMenu();
  initHeaderScroll();
  initServicesSlider();
  initAdvantagesSlider();
  initGoalsLazyLoad();
  initGeographyMapLazy();
  setupClientsInfo();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => fixNavLinkWidths());
  }

  (function () {
    const btn = document.querySelector('.footer__button-arrow-up');
    btn?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  (function () {
    const headerBtn = document.querySelector('.header__action-button');
    const menuBtn = document.querySelector('.header__action-button.menu');
    const footerBtn = document.querySelector('.footer__button-contact');
    const geographyBtn = document.querySelector('.geography__more-btn');
    const servicesBtn = document.querySelector('.services__button');
    const clientsBtn = document.querySelector('.clients__partner-button');
    // const gratitudeBtn = document.querySelector('.footer__button-gratitude');

    headerBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 1 });
      modal.open();
    });
    menuBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 1 });
      modal.open();
    });
    footerBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 1 });
      modal.open();
    });
    geographyBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 3 });
      modal.open();
    });
    servicesBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 2 });
      modal.open();
    });
    clientsBtn?.addEventListener('click', () => {
      const modal = new SubscriptionModal({ type: 3 });
      modal.open();
    });
    // gratitudeBtn?.addEventListener('click', () => {
    //   const modal = new GratitudeModal();
    //   modal.open();
    // });
  })();
}
